import { render, staticRenderFns } from "./dataSafeSdk.vue?vue&type=template&id=81bf8e76&scoped=true"
import script from "./dataSafeSdk.vue?vue&type=script&lang=js"
export * from "./dataSafeSdk.vue?vue&type=script&lang=js"
import style0 from "./dataSafeSdk.vue?vue&type=style&index=0&id=81bf8e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf8e76",
  null
  
)

export default component.exports